import { useEffect, useState } from "react";
import styled from "styled-components";
import DateModalComponent from "../detail/dateModalComponent";

const Wrapper = styled.div``;

const MoveDateInput = styled.div<{}>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8vw;
  border: 0.2vw solid #d8d8d8;
  border-radius: 1vw;
  width: 36vw;
  height: 5.6vw;
  padding: 1vw;
`;

const MoveDateBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
`;
const MoveDateTitle = styled.div`
  height: 3vw;
  display: flex;
  font-size: 2.2vw;
  font-weight: 500;
  flex-direction: column;
  align-items: start;
  color: #000000;
  justify-content: start;
  /* outline: 0.2vw solid red; */
`;

const InputBox = styled.div.attrs({})`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  /* margin-left: 1vw; */
  font-size: 1.8vw;
  font-weight: 500;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: none;
  width: 90%;
  height: 100%;
  &&::placeholder {
    color: #8b8b8b;
    font-weight: 300;
    font-size: 2vw;
    font-family: "Pretendard";
  }
`;
const Required = styled.p`
  font-size: "4vw";
  font-weight: "500";
  color: #ff7f3b;
  margin-left: 0.4vw;
`;
const LabelArea = styled.div`
  display: flex;
  align-items: start;
`;
export default function EnterpriseDateInputComponent(props: any) {
  const { title, dateData, setData, isRequired, name } = props;
  const [date, setDate] = useState(dateData);

  const [isDateModalOpen, setIsDateModalOpen] = useState<boolean>(false);
  const formattedDate = /^(\d{4})(\d{2})(\d{2})$/;

  useEffect(() => {
    setDate(dateData);
  }, [dateData]);

  useEffect(() => {
    setDateData(date);
  }, [date]);

  // 날짜 업데이트 함수
  const setDateData = (value: any) => {
    if (!name) {
      return;
    }
    const paths = name.split(".");
    setData((prev: any) => {
      const updatedData = { ...prev };
      updatedData.contractInfo.detailInfo[paths[paths.length - 1]] = date;
      return updatedData;
    });
  };

  // 날짜 모달 열기 핸들러
  const dateHandleOpenModal = () => {
    setIsDateModalOpen(true);
  };

  // // 날짜 모달 닫기 핸들러
  const dateHandleCloseModal = () => {
    setIsDateModalOpen(false);
  };

  const deleteValue = () => {
    setDate("");
    dateHandleCloseModal();
  };

  return (
    <Wrapper>
      <MoveDateBox>
        <LabelArea>
          <MoveDateTitle>{title}</MoveDateTitle>
          {isRequired && <Required>*</Required>}
        </LabelArea>
        <MoveDateInput
          onClick={() => {
            dateHandleOpenModal();
          }}
        >
          <InputBox>
            {date ? date.replace(formattedDate, "$1-$2-$3") : "--"}
          </InputBox>
        </MoveDateInput>
      </MoveDateBox>
      {isDateModalOpen && (
        <DateModalComponent
          value={date}
          setValue={setDate}
          onClose={dateHandleCloseModal}
          deleteValue={deleteValue}
        />
      )}
    </Wrapper>
  );
}
